module.exports = __webpack_public_path__ + "static/media/coin2.3a0e7bbe.png";